import { Formik, Form, Field, ErrorMessage } from "formik";
import { useEffect, useState, useContext } from "react";
import * as Yup from "yup";
import { Select, Spin } from 'antd';
import FormError from "../../common/FormError";
import { EditableContext } from "../../common/EditableContextProvider";

const FormComponent = ({ errors }) => {
    const { editItem, onFormAction, titulares } = useContext(EditableContext);
    const [initialValues, setInitialvalues] = useState(editItem);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setInitialvalues(editItem);
    }, [editItem]);

    const handleSubmit = async (values, formik) => {
        try {
            setLoading(true);
            await onFormAction(values, formik);
            setInitialvalues(values);
        } catch (e) {
            if (e.code === "REQ_FAIL") {
                if (e.errors.email) { formik.setFieldError("email", e.errors.email[0]); }
            }
        }
        finally { setLoading(false); }
    }

    const validateSchema = Yup.object({
        user_id: Yup.number()
            .required('El campo es obligario.'),
        nombres: Yup.string()
            .min(3, 'El texto debe tener al menos 3 letras.')
            .max(100, 'El texto es demasiado largo')
            .required('El campo es obligario.'),
        apellidos: Yup.string()
            .min(3, 'El texto debe tener al menos 3 letras.')
            .max(100, 'El texto es demasiado largo')
            .nullable(),
        tipo: Yup.string()
            .required('El campo es obligario.'),
        titular_id: Yup.string()
            .required('El campo es obligario.'),
        user: Yup.object({
            email: Yup.string()
                .max(191, 'El texto es demasiado largo')
                .required('El campo es obligario.'),
            password: Yup.string()
                .min(4, 'Ingrese al menos 4 caracteres.')
                .max(200, 'Password demasiado largo.')
                .required('Ingrese una contraseña')
        }),

    });

    return (
        <div>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validationSchema={validateSchema}
                enableReinitialize={true}
            >
                {
                    (formik) => (
                        <Form disabled={loading}>
                            <div className="py-1">
                                <span>ID: </span>
                                <span className="fw-bold ms-1">{sprintf('%04d', editItem.id)}</span>
                            </div>

                            <div className="mb-2">
                                <div className="mb-2 row">
                                    <div className="col-md">
                                        <label htmlFor="nombres" className="form-label">
                                            Nombres
                                            <span className="text-danger">(*)</span>
                                        </label>
                                        <Field id="nombres" name="nombres" type="text" className="form-control form-control-sm" />
                                        <ErrorMessage name="nombres" component={FormError} />
                                    </div>
                                    <div className="col-md">
                                        <label htmlFor="apellidos" className="form-label">
                                            Apellidos
                                        </label>
                                        <Field id="apellidos" name="apellidos" type="text" className="form-control form-control-sm" />
                                        <ErrorMessage name="apellidos" component={FormError} />
                                    </div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-md">
                                        <label htmlFor="email" className="form-label">
                                            E-mail
                                            <span className="text-danger">(*)</span>
                                        </label>
                                        <input id="email" name="email" type="email" className="form-control form-control-sm"
                                            value={formik.values.user.email}
                                            onChange={(e) => {
                                                let user = { ...formik.values.user, email: e.target.value };
                                                formik.setFieldValue('user', user);
                                            }}
                                        />
                                        <ErrorMessage name="user.email" component={FormError} />
                                    </div>
                                    <div className="col-md">
                                        <label htmlFor="password" className="form-label">
                                            Contraseña
                                            <span className="text-danger">(*)</span>
                                        </label>
                                        <input id="password" name="password" type="password" className="form-control form-control-sm"
                                            value={formik.values.user.password}
                                            onChange={(e) => {
                                                let user = { ...formik.values.user, password: e.target.value };
                                                formik.setFieldValue('user', user);
                                            }}
                                        />
                                        <ErrorMessage name="user.password" component={FormError} />
                                    </div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-md">
                                        <label htmlFor="celular" className="form-label">
                                            Celular
                                        </label>
                                        <input id="celular" name="celular" type="text"
                                            className="form-control form-control-sm"
                                            value={formik.values.user.celular ?? ""}
                                            onChange={(e) => {
                                                let user = { ...formik.values.user, celular: e.target.value };
                                                formik.setFieldValue('user', user);
                                            }}
                                        />
                                        <ErrorMessage name="user.celular" component={FormError} />
                                    </div>
                                    <div className="col-md">
                                        <label htmlFor="celular" className="form-label">
                                            Dependiente de:
                                        </label>
                                        <select name="titular_id" id="titular_id" className="form-select form-select-sm"
                                            value={formik.values.titular_id}
                                            onChange={(e) => {
                                                formik.setFieldValue('titular_id', e.target.value);
                                                formik.setFieldValue('titular', titulares.find(t => t.id === parseInt(e.target.value)));
                                            }}
                                        >
                                            <option value="">- Seleccionar -</option>
                                            {
                                                titulares.map(tit => (
                                                    <option key={tit.id} value={tit.id}>{`${tit.nombres} ${tit.apellidos}`}</option>
                                                ))
                                            }
                                        </select>
                                        <ErrorMessage name="titular_id" component={FormError} />
                                    </div>

                                </div>

                                <div className="mb-2">
                                    <label htmlFor="estado" className="form-label" >
                                        <input name="estado" id="estado" type="checkbox" className="form-checkbox me-2"
                                            checked={formik.values.user.estado}
                                            onChange={(e) => {
                                                let user = { ...formik.values.user, estado: e.target.checked };
                                                formik.setFieldValue('user', user);
                                            }}
                                        />
                                        Activo
                                    </label>
                                    <ErrorMessage name="user.estado" component={FormError} />
                                </div>
                            </div>

                            <div className="mb-2 d-flex justify-content-between">
                                <div>
                                    <span className="text-danger">(*) </span>
                                    <u>Campo obligatorio.</u>
                                </div>
                                <button type="submit" className="btn btn-sm btn-light border border-secondary px-4">
                                    {
                                        (loading) ? (
                                            <Spin size="small" />
                                        ) : "Guardar"
                                    }
                                </button>
                            </div>
                        </Form>
                    )
                }
            </Formik>
        </div>
    );
}

export default FormComponent;